<template>
  <div>
    <!-- <p class="c-inner-title">外链图文</p> -->
    <div class="auto">
      <page-title title="外链图文" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" size="small" @click="addHandle()">添加素材</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-input v-model="filter.search" size="small" clearable class="m-lr-5" style="width:200px;" placeholder="请输入图文备注进行搜索"><i class="el-icon-search el-input__icon" slot="suffix"></i></el-input>
              <el-button type="primary" size="small" @click="handleChangeFilter()">搜索</el-button>
            </el-col>
          </el-row>
          <el-row v-loading="loading">
            <el-col :span="24" class="masonry">
              <!-- {{tableData}} -->
              <div class="list-box" v-for="(item, index) in tableData" :key="index">
                <div class="auto" style="width:100%;" v-if="item.type === 'news'">
                  <div class="listbox-top">
                    <dl class="noposter" v-if="!!!item.content.articles[0].picurl">
                      <dt>{{item.content.articles[0].title}}</dt>
                      <dd>{{item.content.articles[0].description}}</dd>
                    </dl>
                    <div class="hasposterBox" v-else>
                      <dl class="hasposter">
                        <dt>{{item.content.articles[0].title}}</dt>
                        <dd><img :src="item.content.articles[0].picurl" alt=""></dd>
                      </dl>
                    </div>
                    <a :href="item.content.articles[0].url" target="_blank"><span>预览文章</span></a>
                  </div>
                  <div class="listbox-item" v-if="item.content.articles.length > 1 && index2 > 0" v-for="(item2, index2) in item.content.articles" :key="index2">
                    <div class="listbox-itembox">
                      <dl>
                        <dt>{{item2.title}}</dt>
                        <dd><img :src="item2.picurl" v-if="item2.picurl" alt=""></dd>
                      </dl>
                      <a :href="item2.url" target="_blank"><span>预览文章</span></a>
                    </div>
                  </div>
                </div>
                <div class="auto" v-else-if="item.type === 'music'">
                  <div class="listbox-item" style="margin-top: 0px;">
                    <div class="listbox-itembox">
                      <dl>
                        <dt>{{item.content.title}}</dt>
                        <dd><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAaVBMVEUAAAAarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRlIa6J1AAAAInRSTlMA9wYa38QR7ZJnMK1IIqBsO3fXDbSGQudZz5fKpV0rfbpRlHIjYQAAA35JREFUWMPFWduyqjAMDS0tgtwEFBGv/P9Hntmh3cWDTYsMs/Oio3SRy0qapuCU7PXIRdUGQxCFncgfrwzWCb/l4TCTML/xbxFlIQariEJ+AZnkwUBKkCdLIZvBQ5olsPw61Uhc4vTOa4Ca39P4IqYWXH2dyw5mWXUs2ez/8liZVx6YD2bW6wXRzmpesov0U70HxW5azTBmpD1xqJW9uUzfaS0Lp1ms0Nru6Nfv9WPSi8lahT2BKoWyvARPKZUPhLRiduq9ckHaKds6y5pa6XmARXJQutaEP4MzLJTzyJfmk193I2YKiyUdUXcf+OnCdKPO+JqNvxO2kx4YNcr+c2jvjpE7Wv27W4uRS/C1jFEu3mpdhJyX34PWISY3ByNj/SxhhZRjfZ0UMkUJt3Bxx08rJU2xbFB16YEZDiG3JSy6sHlXNPbCHIbOVpHiN1VzjBLzKOCkmxjGKld6B4oNbjkiqi3rkJeBNN8jBj7SUEaxyGgnjE1OkS0mHkUAgd5X/qWF80mWR7PaOY0410GrnHHXVHpSqlZII521RzeXqtpkTkgEEitIiwF1YeLDJgQnIldbgAx5wMBj5z4br+aWB5GdGbxUxGjUp6ESLmxhJsaMFzx+Pi5+VIpN6bTUlcvPfw/InXlvjO5MjsdE/ucg6DjxRlEJY4Wb0J1IlnR0ZoXGEHF/6l1I68d+vj3ho9xH0mO+cjumNiMxvg/tTOWYcIAkqCl+XjRbtH7CHv4aCQrIQIui3TCxNPyN1BMXfhQFFxCgJ/yzmYAaTpGgEZpPoOq60GJctfkRaX5IBApRVTNTm/TvnYHqCEoh6kMzUCuNxnUUpVzkB/2+/Pc5iTpT5PdNUx78FrMT6kymqbugmEpxNZU4JXaph7v0GbOGxJQ3SZU+ryINSWT8iAt6skg7txPD1wCJN/rrQG0nZuNzo54nHQOnNj6zRTtRj5Pe5klu0d7NBGTThvFENhNE20NQS5BtD9GgUdQqyQZtaSuZ4bIr1fUGcmHTCz1SRpJNL9GeE3xNHe35/CDhRj04DhLzI48b9eI48mxxONvyGLn+wGtsLTY5mm87RFg/7jhNxh3bD2aANWtHSFsOu7Yfy60fIG4/6lw/lN14fOwedJdWXxKD7m1H8u7LAwZMZsn88mCDa46/v5DZ6OoIhcf7dg7Y7mPalb7XcVEwDEFU+V3H/QOplcP+ctPpgwAAAABJRU5ErkJggg==" alt=""></dd>
                      </dl>
                      <a :href="item.content.musicurl" target="_blank"><span>预览文章</span></a>
                    </div>
                  </div>
                </div>
                <div class="auto" v-else-if="item.type === 'video'">
                  <div class="listbox-item" style="margin-top: 0px;">
                    <div class="listbox-itembox">
                      <dl>
                        <dt>{{item.content.title}}</dt>
                        <dd><img src="data:image/svg+xml;charset=utf8, <svg width='45' height='45' viewBox='0 0 45 45' xmlns='http://www.w3.org/2000/svg'><g fill='none' fill-rule='evenodd'><circle stroke='%23FFF' stroke-width='2.3' cx='22.5' cy='22.5' r='21.35'/><g fill='%23FFF'><path d='M16.13 17h10.74c.624 0 1.13.506 1.13 1.13v8.74A1.13 1.13 0 0 1 26.87 28H16.13A1.13 1.13 0 0 1 15 26.87v-8.74c0-.624.506-1.13 1.13-1.13zM29 23.72v-2.388c1.158-1.063 2.91-2.929 3.011-3.06.509-.66.989.101.989 0v8.521c0-.15-.477.533-.989 0-.117-.122-1.847-2.008-3.011-3.074zm-1-1.181z'/></g></g></svg>" alt=""></dd>
                      </dl>
                      <a :href="item.content.url" target="_blank"><span>预览文章</span></a>
                    </div>
                  </div>
                </div>
                <div class="control">
                  <span style="float: left;">
                    <el-tooltip class="tip-item" effect="dark" placement="top">
                      <div slot="content">{{item.remark}}</div>
                      <i class="el-icon-chat-line-square" small></i>
                    </el-tooltip>
                  </span>
                  <a href="javascript:;" class="m-l-5" @click="testHandle(item)">测试</a>
                  <a href="javascript:;" class="m-l-5" @click="editHandle(index)" v-show="!item.is_use">编辑</a>
                  <a href="javascript:;" class="m-l-5" @click="deleteNewsHandle(index)" v-show="!item.is_use">删除</a>
                  <el-tooltip class="item" effect="dark" content="正在使用中的素材无法进行编辑、删除，如需修改请先将素材取消使用" v-show="item.is_use" placement="top" style="float:right;margin-left:10px;margin-top:2px;">
                    <i class="fa fa-question-circle-o gray80"></i>
                  </el-tooltip>
                </div>
              </div>
            </el-col>
          </el-row>
          <div v-if="count > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="添加图文素材" :visible.sync="dialogVisible" :before-close="handleClose" class="replyDialog" width="80%">
      <div v-loading="submitloading">
        <el-row>
          <el-col :span="6">
            <div class="paBox">
              <div class="patop" @click="choosePa(0)">
                <div class="imgbox">
                  <img v-if="newsArr[0] && newsArr[0].picurl" :src="newsArr[0].picurl" alt="">
                  <p><span>{{newsArr[0] && newsArr[0].title ? newsArr[0].title : '标题'}}</span></p>
                </div>
                <div class="pamask" v-show="newsIndex === 0"></div>
              </div>
              <div class="palist" v-if="newsArr.length > 1 && index > 0" v-for="(item, index) in newsArr" :key="index" @click="choosePa(index)">
                <dl>
                  <dt>{{newsArr[index].title}}</dt>
                  <dd>
                    <img v-if="newsArr[index].picurl" :src="newsArr[index].picurl" alt="">
                  </dd>
                </dl>
                <div class="pamask" v-show="newsIndex === index"></div>
                <div class="patopedit">
                  <i class="el-icon-delete" @click="deleteHandle(index)"></i>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="16">
            <el-row>
              <el-col :span="24">
                <el-form ref="form" :model="current" :rules="rules" label-width="80px">
                  <el-form-item label="标题" prop="title">
                    <el-input v-model.trim="current.title"></el-input>
                  </el-form-item>
                  <el-form-item label="简介" prop="description">
                    <el-input v-model.trim="current.description"></el-input>
                  </el-form-item>
                  <el-form-item label="预览链接" prop="url">
                    <el-input v-model.trim="current.url"></el-input>
                  </el-form-item>
                  <el-form-item label="封面图片" prop="picurl">
                    <el-upload
                      class="avatar-uploader"
                      :action="config.root + '/mp/material/uploadMaterial'"
                      :data="uploadData"
                      :show-file-list="false"
                      v-loading="uploadLoading"
                      :on-success="handleAvatarSuccess"
                      :on-error="uploadError"
                      :before-upload="beforeAvatarUpload">
                      <img v-if="current.picurl" :src="current.picurl" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form ref="remarkform" :model="remark" :rules="remarkrules" label-width="80px">
              <el-form-item label="备注" prop="remark">
                <el-input v-model.trim="remark.remark" placeholder="可填写关键字或标题等信息，方便图文精确搜索"></el-input>
              </el-form-item>
              <el-form-item label="">
                <span class="font12" style="color:#F56C6C;">Tips：如果此素材是用于京东平台推送，请填写原始链接在素材内，切勿将原始链接替换成荧识跳转链接，京东平台在推送时，会自动将原始链接替换为特殊的跳转链接。</span>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="测试" :modal-append-to-body="false" :visible.sync="testVisible" @close="handleTestClose" width="600px">
      <el-form ref="testText" :rules="testrules" :model="test" label-width="90px" size="small" v-loading="btnLoading">
        <el-form-item prop="openid" label="openid">
          <el-input type="text" v-model.trim="test.openid" placeholder="请输入测试用户的openid"></el-input>
        </el-form-item>
        <el-form-item prop="" label="">
          <p class="font12 gray80" style="line-height: 20px;">tips:测试用户的openid可以在 "用户"=>"详情" 中搜索微信昵称等方式获取,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;测试用户必须48小时内与公众号产生过互动(如发送消息、点击自定义菜单等)</p>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="primary" @click="handleTest">确定</el-button>
        <el-button @click="handleTestClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VueCookie from 'vue-cookie'
import { Mp } from '@/model'
import Config from '@/conf'
export default {
  data () {
    let token = VueCookie.get(Config['token_key'])
    let authorizer = VueCookie.get(Config['current_key'])
    return {
      uploadData: { token, authorizer },
      currentId: '',
      tableData: [],
      loading: false,
      submitloading: false,
      uploadLoading: false,
      syncLoading: false,
      dialogVisible: false,
      activeName: 'news',
      newsArr: [
        {
          title: '',
          description: '',
          url: '',
          picurl: ''
        }
      ],
      newsIndex: 0,
      current: {
        title: '',
        description: '',
        url: '',
        picurl: ''
      },
      rules: {
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请填写简介', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请填写预览链接', trigger: 'blur' }
        ],
        picurl: [
          { required: true, message: '请上传封面图片', trigger: 'blur' }
        ]
      },
      remark: {
        remark: ''
      },
      remarkrules: {
        remark: [
          { required: true, message: '请填写备注', trigger: 'blur' }
        ]
      },
      isEdit: false,
      filter: {
        type: 'news',
        search: '',
        page: '1',
        limit: '10'
      },
      count: 0,
      btnLoading: false,
      testVisible: false,
      test: {
        openid: '',
        type: '',
        id: ''
      },
      testrules: {
        openid: [
          { required: true, message: 'openid不能为空！', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    '$route': function (val) {
      this.queryToFilter()
    },
    current: {
      handler: function (newVal, oldVal) {
        this.newsArr[this.newsIndex] = this.current
      },
      deep: true
    }
  },
  components: {
  },
  methods: {
    handleTest () {
      this.$refs['testText'].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true
          let res = await Mp.Reply.previewMessage(this.test)
          if (res && !res['err_code']) {
            this.$message.success('测试信息已发出，请注意查收！')
          } else {
            this.$message.error(res.err_msg)
          }
          this.btnLoading = false
        }
      })
    },
    handleTestClose () {
      this.test = {
        id: '',
        openid: '',
        type: ''
      }
      this.testVisible = false
    },
    testHandle (item) {
      this.test = {
        id: item.id,
        openid: '',
        type: item.type
      }
      this.testVisible = true
    },
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        type: 'news',
        search: '',
        page: '1',
        limit: '10'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/reply/article', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    handleAvatarSuccess (res, file) {
      this.current.picurl = res.data.oss_url
      this.uploadLoading = false
    },
    beforeAvatarUpload (file) {
      this.uploadLoading = true
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        this.uploadLoading = false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        this.uploadLoading = false
      }
      return isJPG && isLt2M
    },
    uploadError () {
      this.uploadLoading = false
      this.$message.error('上传失败，请重新上传')
    },
    deleteHandle (index) {
      this.$confirm('确定要删除此条内容吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteFn(index)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    deleteFn (index) {
      this.newsArr.splice(index, 1)
      this.newsIndex--
      this.current = this.newsArr[this.newsIndex]
    },
    addNews () {
      this.newsArr.push({
        title: '',
        description: '',
        url: '',
        picurl: ''
      })
      this.newsIndex = this.newsArr.length - 1
      this.current = {
        title: '',
        description: '',
        url: '',
        picurl: ''
      }
    },
    editHandle (index) {
      this.isEdit = true
      this.dialogVisible = true
      this.current = Object.assign({}, this.tableData[index].content.articles[0])
      this.newsArr = Object.assign([], this.tableData[index].content.articles)
      this.remark.remark = this.tableData[index].remark
      this.currentId = this.tableData[index].id
    },
    choosePa (index) {
      this.newsIndex = index
      this.current = this.newsArr[this.newsIndex]
    },
    checkForm () {
      setTimeout(() => {
        this.$refs['form'].validate((valid) => {})
      }, 100)
    },
    handleClose () {
      this.dialogVisible = false
      this.resetForm()
    },
    handleSubmit () {
      for (var i = 0; i < this.newsArr.length; i++) {
        for (var key in this.newsArr[i]) {
          if (this.newsArr[i][key].trim() === '') {
            this.$message.error('请填写所有项')
            this.newsIndex = i
            this.current = this.newsArr[this.newsIndex]
            this.checkForm()
            return
          }
        }
      }
      this.checkForm()
      this.saveLocalMaterialInfo()
    },
    saveLocalMaterialInfo () {
      this.$refs['remarkform'].validate(async (valid) => {
        if (valid) {
          this.submitloading = true
          var list = {
            'articles': this.newsArr
          }
          let res = await Mp.Reply.saveLocalMaterialInfo({
            id: this.isEdit ? this.currentId : '',
            type: this.filter.type,
            content: list,
            remark: this.remark.remark
          })
          if (res.err_code === 0) {
            this.$message.success('提交成功')
            this.handleClose()
            this.resetForm()
            this.resetFilter()
            this.getList()
          } else {
            this.$message.error(res.err_msg)
          }
          this.submitloading = false
        } else {
          this.$message.error('请填写备注')
        }
      })
    },
    resetForm () {
      this.newsArr = [{
        title: '',
        description: '',
        url: '',
        picurl: ''
      }]
      this.newsIndex = 0
      this.current = {
        title: '',
        description: '',
        url: '',
        picurl: ''
      }
      this.remark.remark = ''
      this.$refs['form'].resetFields()
      this.isEdit = false
    },
    async getList () {
      this.loading = true
      let res = await Mp.Reply.getMaterialLocalList(this.filter)
      this.tableData = res['data']['list']
      this.count = res['data']['total']
      this.loading = false
      this.syncLoading = false
    },
    addHandle () {
      this.dialogVisible = true
    },
    deleteNewsHandle (index) {
      this.$confirm('确定要删除此条内容吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteNewsFn(index)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async deleteNewsFn (index) {
      this.loading = true
      let res = await Mp.Reply.delLocalMaterial({type: this.filter.type, id: this.tableData[index].id})
      if (res.err_code === 0) {
        this.$message.success('删除成功')
        this.getList()
      } else {
        this.$message.error(res.err_msg)
        this.loading = false
      }
    }
  },
  created () {
    this.queryToFilter()
  }
}
</script>

<style scoped>
.masonry {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.list-box {
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0,0,0,.1);
  border-radius: 5px;
  border: 1px solid #eee;
  float: left;
  height: auto;
  overflow: hidden;
  margin: 5px 0;
}
@media (min-width: 600px) {
  .list-box {
    width: calc(30% - 22px);
    margin-right: 3%;
  }
}
@media (min-width: 1200px) {
  .list-box {
    width: calc(22% - 22px);
    margin-right: 3%;
  }
}
@media (min-width: 1600px) {
  .list-box {
    width: calc(17% - 22px);
    margin-right: 3%;
  }
}
.listbox-top {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  position: relative;
}
.listbox-top dl dt {
  font-size: 16px;
}
.noposter dd {
  color: #9a9a9a;
  font-size: 12px;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  padding-top: 10px;
}
.hasposterBox {
  position: relative;
  height: auto;
  overflow: hidden;
}
.hasposter {
  position: relative;
}
.hasposter dt {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 8px 5%;
  background: rgba(0,0,0,.55);
  color: #fff;
  width: 90%;
}
.hasposter dd {
  height: 130px;
  overflow: hidden;
}
.hasposter dd img{
  width: 100%;
  display: block;
}
.listbox-top a {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 10px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-top:hover a {
  display: block;
}
.listbox-top a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 45%;
  /*margin-top: -10px;*/
}
.listbox-item {
  width: 100%;
  margin-top: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.listbox-item dl {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
}
.listbox-item dl dt {
  position: absolute;
  right: 70px;
  left: 0;
  font-size: 14px;
  line-height: 20px;
}
.listbox-item dl dd {
  width: 60px;
  height: 60px;
  float: right;
  background: #eee;
}
.listbox-item dl dd img{
  width: 100%;
}
.listbox-itembox {
  position: relative;
}
.listbox-itembox a{
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-itembox:hover a {
  display: block;
}
.listbox-itembox a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 30%;
  /*margin-top: -10px;*/
}
.list-box .control{
  width: 100%;
  margin-top: 10px;
  text-align: right;
}
.list-box .control a{
  color: #409EFF;
}

.paBox{
  max-width: 240px;
}
.patop {
  border: 1px solid #eee;
  padding: 10px;
  position: relative;
}
.imgbox{
  background: #eee;
  width: 100%;
  min-height: 120px;
  max-height: 120px;
  overflow: hidden;
  position: relative;
}
.imgbox img{
  max-width: 100%;
  max-height: 100%;
}
.imgbox p{
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0,0,0,.2);
}
.imgbox p span{
  display: block;
  padding: 10px;
  color: #fff;
  left: 0;
  bottom: 0;
  position: absolute;
  font-size: 14px;
  line-height: 18px;
  max-height: 36px;
  overflow: hidden;
}
.pamask{
  position: absolute;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  border: 2px solid #409EFF;
}
.palist:hover .patopedit {
  display: block;
}
.patopedit {
  position: absolute;
  width: 100%;
  background: rgba(0,0,0,.8);
  left: 0;
  bottom: 0;
  padding: 10px 0;
  display: none;
}
.patopedit i{
  color: #fff;
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
.palist {
  position: relative;
  border: 1px solid #eee;
  /*margin-top: -1px;*/
  padding: 10px;
  height: auto;
  height: 60px;
}
.palist dl dd{
  width: 60px;
  height: 60px;
  background: #eee;
  float: right;
  overflow: hidden;
}
.palist dl dd img{
  max-width: 100%;
  max-height: 100%;
}
.palist dl dt{
  position: absolute;
  left: 10px;
  top: 10px;
  height: 60px;
  line-height: 60px;
  overflow: hidden;
}
.paAdd {
  cursor: pointer;
  border: 1px dashed #eee;
  max-width: 238px;
  text-align: center;
  padding: 20px 0;
  border-top: none;
}
.paAdd i{
  font-size: 30px;
}
.dialog-footer {
  text-align: right;
  padding-bottom: 30px;
}
</style>
